import React, { useState } from "react";
import ModalConfirm from "../../molecules/ModalConfirm";
import Modal from "../../molecules/Modal";
import NoData from "../../atoms/NoData";
import { PropagateLoader } from "react-spinners";
import DataTable from "react-data-table-component";
import Button from "../../atoms/Button";
import { MdDelete, MdEdit } from "react-icons/md";
import { toast } from "react-toastify";
import useModal from "../../../hooks/useModal";
import ModalEditUsuarioRS from "./ModalEditUsuarioRS";
import { DELETE_USER_RS } from "../../../api/apiAdmin";
import { getConditionalRowStyles } from "../../../styles/expandedStyles";

const TableUsuariosRS = ({ data, loading, refetch }) => {
    const [usuario, setUsuario] = useState();
    const [expandedRow, setExpandedRow] = useState(null);
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();

    const handleOpenEdit = (user) =>{
        setUsuario(user);
        open2();
    };

    const handleOpenDelete = (user) => {
        setUsuario(user);
        open3();
    };

    const handleDelete = async () => {
        try {
            await DELETE_USER_RS(usuario?.id);
            toast.success("Eliminado correctamente");
            refetch();
            close3();
        } catch (error) {
            toast.error("Error al eliminar");
            console.error(error);
        }
    };
    
const findFather = (nodeJefe) => {
    if (!nodeJefe || !Array.isArray(data)) return "No registrado";
    
    const nombreJefe = data.find(
        (row) => row.actualNode === nodeJefe
    );

    return nombreJefe?.name || "No registrado";
};
    const columns = [
        {name: "Nombre", selector: row => row.name},
        {name: "Correo electrónico", selector: row => row.email},
        {name: "Nodo padre", selector: row => findFather(row?.parentNode)},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-2">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={()=> handleOpenDelete(row)}/>
            </div>
        )},
    ];

    const columnsResponsive = [
        {name: "Información", cell: row => (
            <div className="flex flex-col">
                <p> {row.name} </p>
                <p> {row.email} </p>
            </div>
        )},
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="p-2 w-full flex flex-row justify-around">
            <Button
                text={<MdEdit size={22} />}
                bgColor="blue"
                width="w-10"
                onClick={() => handleOpenEdit(data)}
            />
            <Button
                text={<MdDelete size={22} />}
                bgColor="red"
                width="w-10"
                onClick={() => handleOpenDelete(data)}
            />
        </div>
    );

    const conditionalRowStyles = getConditionalRowStyles(expandedRow);

    return(
        <div>
            <div className="block md:hidden">
                <DataTable 
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div> }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                    onRowExpandToggled={(expanded, row) => {
                        setExpandedRow(expanded ? row : null);
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="hidden md:block">
                <DataTable 
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                />
            </div>
            {isOpen2 && 
                <Modal title="Editar contador" onClose={close2}>
                    <ModalEditUsuarioRS onClose={close2} refetch={refetch} usuario={usuario} usuarios={data} />
                </Modal>
            }
            {isOpen3 && 
                <ModalConfirm onClose={close3} onConfirm={handleDelete} eliminacion />
            }
        </div>
    );
};

export default TableUsuariosRS;